import ClearIcon from '@mui/icons-material/Clear';
import { InputLabel, MenuItem, FormControl, Select, Button } from '@mui/material';
import Cookies from 'js-cookie';
import React, { useState, useEffect, useRef } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { ref, get, update, remove } from 'firebase/database';
import { getStudents, getTeachers, updateStatisticsFunc } from '../../Common/Database';
import { database } from '../../Common/Firebase';
import Modal from '../../Components/CreateStudentModal';
import Loader from '../../Components/Loader';
import NoItems from '../../Components/NoItems';
import ResetButton from '../../Components/ResetButton';
import Tooltipe from '../../Components/Tooltipe';
import { throwErrorRollbar } from '../../index';
import { setStudentNames } from '../../redux/slices/nameStudentsSlice';
import { getUserType } from '../../redux/slices/userSlice';

import './style.scss';

const { SearchBar } = Search;

const StudentList = ({ mail }) => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const userTypeSelector = useSelector(getUserType);

  const selectedFilterBranch = JSON.parse(Cookies.get('selectedFilterBranch') ?? '{}');

  const selectedFilterAge = JSON.parse(Cookies.get('selectedFilterAge') ?? '{}');

  const selectedFilterCity = JSON.parse(Cookies.get('selectedFilterCity') ?? '{}');

  const selectedFilterSubject = JSON.parse(Cookies.get('selectedFilterSubject') ?? '{}');

  const selectedFilterClass = JSON.parse(Cookies.get('selectedFilterClass') ?? '{}');

  const [studetnItems, setStudetnItems] = useState([]);
  const [unicBranch, setUnicBranch] = useState([]);
  const [unicAge, setUnicAge] = useState([]);
  const [unicCity, setUnicCity] = useState([]);
  const [unicSubject, setUnicSubject] = useState([]);
  const [unicClass, setUnicClass] = useState([]);
  const [studetnActive, setStudentActive] = useState();
  const [studentParamsId, setStudentParamsId] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [student, setStudent] = useState([]);
  const [popupRemove, setPopupRemove] = useState(false);
  const [userType, setUserType] = useState(userTypeSelector);

  const [selectedBranch, setSelectedBranch] = useState(selectedFilterBranch.selectedBranch ?? '');

  const [selectedAge, setSelectedAge] = useState(selectedFilterAge.selectedAge ?? '');

  const [selectedCity, setSelectedCity] = useState(selectedFilterCity.selectedCity ?? '');

  const [selectedSubject, setSelectedSubject] = useState(selectedFilterSubject.selectedSubject ?? '');

  const [selectedClass, setSelectedClass] = useState(selectedFilterClass.selectedClass ?? '');

  const admins = userType === 'NewAdmin' || userType === 'Admin' || userType === 'Superadmin';

  const canManageStudents = admins || userType === 'Teacher';

  const onStudentBranch = e => {
    selectedFilterBranch.selectedBranch = e.target.value;
    Cookies.set('selectedFilterBranch', JSON.stringify(selectedFilterBranch));
    setSelectedBranch(e.target.value);
  };

  const onStudentAge = e => {
    selectedFilterAge.selectedAge = e.target.value;
    Cookies.set('selectedFilterAge', JSON.stringify(selectedFilterAge));
    setSelectedAge(e.target.value);
  };

  const onStudentCity = e => {
    selectedFilterCity.selectedCity = e.target.value;
    Cookies.set('selectedFilterCity', JSON.stringify(selectedFilterCity));
    setSelectedCity(e.target.value);
  };

  const onStudentSubject = e => {
    selectedFilterSubject.selectedSubject = e.target.value;
    Cookies.set('selectedFilterSubject', JSON.stringify(selectedFilterSubject));
    setSelectedSubject(e.target.value);
  };

  const onStudentClass = e => {
    selectedFilterClass.selectedClass = e.target.value;
    Cookies.set('selectedFilterClass', JSON.stringify(selectedFilterClass));
    setSelectedClass(e.target.value);
  };

  const fetchStudentsListData = async () => {
    const studentsList = await getStudents(selectedBranch, selectedAge, selectedCity, selectedClass, selectedSubject);
    if (studentsList) {
      let mapList = Object.values(studentsList);

      if (userType === 'Teacher') {
        const filteredMapList = mapList.filter(student => {
          if (student.subjects && Object.keys(student.subjects).length > 0) {
            for (const subjectKey in student.subjects) {
              const subject = student.subjects[subjectKey];

              if (
                (subject.attachedTeacher && subject.attachedTeacher.id === mail) ||
                student.createdByTeacher === mail
              ) {
                return true;
              }
            }
          }
          return false;
        });

        setStudetnItems(filteredMapList);
        dispatch(setStudentNames(filteredMapList));
      } else {
        setStudetnItems(mapList);
        dispatch(setStudentNames(mapList));
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStudentsListData();
    setUserType(userTypeSelector);
    fetchBranch();
    fetchAge();
    fetchCity();
    fetchClass();
    fetchSubject();
  }, [selectedBranch, selectedAge, selectedCity, selectedClass, selectedSubject, userTypeSelector, userType]);

  const filterStudentsList = (studentsList, mail) => {
    const mapList = Object.values(studentsList);

    return mapList.filter(student => {
      const createdByTeacher = student.createdByTeacher === mail;

      const assignedToTeacher = Object.values(student.subjects || {}).some(
        subject => subject?.attachedTeacher?.id === mail,
      );

      return createdByTeacher || assignedToTeacher;
    });
  };

  const fetchBranch = async () => {
    const studentsList = await getStudents();
    const filteredMapList = filterStudentsList(studentsList, mail);

    if (userType === 'Teacher') {
      if (studetnItems) {
        const uniqArr = [
          ...new Set(filteredMapList.map(item => item.branch).filter(branch => branch && branch.trim() !== '')),
        ];
        uniqArr.sort((a, b) => a - b);
        setUnicBranch(uniqArr);
      }
    }
    if (admins) {
      let mapList = Object.values(studentsList);
      const uniqArr = [...new Set(mapList.map((item, i) => item.branch))].map(item => {
        if (item && item.length) {
          return item;
        }
      });
      uniqArr.sort();
      setUnicBranch(uniqArr);
    }
  };

  const fetchAge = async () => {
    const studentsList = await getStudents();
    const filteredMapList = filterStudentsList(studentsList, mail);

    if (userType === 'Teacher') {
      if (studetnItems) {
        const uniqArr = [...new Set(filteredMapList.map(item => item.age).filter(age => age && age.trim() !== ''))];
        uniqArr.sort((a, b) => a - b);
        setUnicAge(uniqArr);
      }
    }
    if (admins) {
      let mapList = Object.values(studentsList);
      const uniqArr = [...new Set(mapList.map((item, i) => item.age))].map(item => {
        if (item && item.length) {
          return item;
        }
      });
      uniqArr.sort((a, b) => a - b);
      setUnicAge(uniqArr);
    }
  };

  const fetchCity = async () => {
    const studentsList = await getStudents();
    const filteredMapList = filterStudentsList(studentsList, mail);

    if (userType === 'Teacher') {
      if (studetnItems) {
        const uniqArr = [...new Set(filteredMapList.map(item => item.city).filter(city => city && city.trim() !== ''))];
        uniqArr.sort((a, b) => a - b);
        setUnicCity(uniqArr);
      }
    }
    if (admins) {
      let mapList = Object.values(studentsList);
      const uniqArr = [...new Set(mapList.map((item, i) => item.city))].map(item => {
        if (item && item.length) {
          return item;
        }
      });
      uniqArr.sort();
      setUnicCity(uniqArr);
    }
  };

  const fetchSubject = async () => {
    const studentsList = await getStudents();
    const filteredMapList = filterStudentsList(studentsList, mail);

    if (userType === 'Teacher' && studetnItems) {
      const activeSubjects = filteredMapList
        .filter(item => {
          const subjects = item.subjects;
          if (subjects) {
            for (const subjectKey in subjects) {
              const subject = subjects[subjectKey];
              if (subject.activeSub === true) {
                return true;
              }
            }
          }
          return false;
        })
        .map(item => {
          const subjects = item.subjects;
          return Object.keys(subjects).filter(
            subjectKey =>
              subjects[subjectKey].activeSub === true &&
              subjects[subjectKey].attachedTeacher &&
              subjects[subjectKey].attachedTeacher.id === mail,
          );
        });

      const uniqArr = [...new Set(activeSubjects.flat())];
      uniqArr.sort((a, b) => a.localeCompare(b));
      setUnicSubject(uniqArr);
    }

    if (admins) {
      let mapList = studentsList[0].subjects;
      const subjectsArr = [];
      for (let key in mapList) {
        subjectsArr.push(key);
      }
      setUnicSubject(subjectsArr);
    }
  };

  const fetchClass = async () => {
    const studentsList = await getStudents();
    const filteredMapList = filterStudentsList(studentsList, mail);

    if (userType === 'Teacher') {
      if (studetnItems) {
        const uniqArr = [
          ...new Set(
            filteredMapList.map(item => item.classStudent).filter(stClass => stClass && stClass.trim() !== ''),
          ),
        ];
        uniqArr.sort((a, b) => a - b);
        setUnicClass(uniqArr);
      }
    }
    if (admins) {
      let mapList = Object.values(studentsList);
      const uniqArr = [...new Set(mapList.map((item, i) => item.classStudent))].map(item => {
        if (item && item.length) {
          return item;
        }
      });
      uniqArr.sort((a, b) => a - b);
      setUnicClass(uniqArr);
    }
  };

  const removeStudent = () => {
    if (admins) {
      removeStudentFromDB();
    } else {
      updateStudent();
    }
  };

  const removeStudentFromDB = async () => {
    const stId = localStorage.getItem('studentId');

    await remove(ref(database, `Students/${stId}`), {
      stId,
    });
    updateStatisticsFunc('FindingStudentsSite', 'decrement');
    localStorage.removeItem('studentId');
    fetchStudentsListData();
    setPopupRemove(false);

    setTimeout(() => {
      searchRef.current.props.onSearch('');
    }, 0);
  };

  const updateStudent = async () => {
    const stId = localStorage.getItem('studentId');

    const studentsRef = ref(database, 'Students');
    const snapshot = await get(studentsRef);

    if (!snapshot.exists()) {
      console.log('Students not found');
      return;
    }

    const students = snapshot.val();

    const studentEntry = Object.entries(students).find(([key, student]) => {
      const studentEmailId = student.email?.replace(/\./g, '');
      return studentEmailId === stId;
    });

    if (!studentEntry) {
      console.log('Student not found');
      return;
    }

    const [studentKey, student] = studentEntry;

    const updatedSubjects = { ...student.subjects };

    Object.entries(updatedSubjects).forEach(([subjectKey, subject]) => {
      if (subject?.attachedTeacher?.id === mail) {
        updatedSubjects[subjectKey] = {
          ...subject,
          attachedTeacher: null,
        };
      }
    });

    await update(ref(database, `Students/${studentKey}`), {
      createdByTeacher: null,
      subjects: updatedSubjects,
      active: true,
    });

    fetchStudentsListData();
    setPopupRemove(false);
  };

  const notRemoveStudent = () => {
    localStorage.removeItem('studentId');
    setPopupRemove(false);
  };

  const handleClearFilters = () => {
    setSelectedAge('');
    setSelectedBranch('');
    setSelectedCity('');
    setSelectedSubject('');
    setSelectedClass('');

    Cookies.set('selectedFilterBranch', JSON.stringify({}));
    Cookies.set('selectedFilterAge', JSON.stringify({}));
    Cookies.set('selectedFilterCity', JSON.stringify({}));
    Cookies.set('selectedFilterSubject', JSON.stringify({}));
    Cookies.set('selectedFilterClass', JSON.stringify({}));
    setTimeout(() => {
      searchRef.current.props.onSearch('');
    }, 0);
  };

  const columns = admins
    ? [
        { dataField: 'id', hidden: true },
        {
          dataField: 'FIO',
          text: t('fio'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('fio') },
          sort: true,
        },
        {
          dataField: 'email',
          text: t('email'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('email') },
        },
        {
          dataField: 'age',
          text: t('age'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('age') },
          formatter: cell => {
            return cell !== '' ? cell : '-';
          },
        },
        {
          dataField: 'classStudent',
          text: t('class'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('class') },
          formatter: cell => {
            return cell !== '' ? cell : '-';
          },
        },
        {
          dataField: 'city',
          text: t('city'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('city') },
          formatter: cell => {
            return cell !== '' ? cell : '-';
          },
        },
        {
          dataField: 'branch',
          text: t('branch'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('branch') },
          formatter: cell => {
            return cell !== '' ? cell : '-';
          },
        },
        {
          dataField: 'subjects',
          text: t('subjects'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('subjects') },
          formatter: cell => {
            const filteredSubjects = [];
            for (let key in cell) {
              if (cell[key].attachedTeacher) {
                const id = JSON.parse(localStorage.getItem('user')).email.replace(/\./g, '');
                if (id === cell[key].attachedTeacher.id) {
                  filteredSubjects.push(t(`${cell[key].name}`));
                }
              }
            }
            const filteredObjectsLocale = filteredSubjects.sort((a, b) => t(a).localeCompare(t(b)));

            return (
              <>
                {filteredObjectsLocale.map(item => {
                  return (
                    <React.Fragment key={item}>
                      <span>{item}</span>
                      <br className="hideBr"></br>
                    </React.Fragment>
                  );
                })}
              </>
            );
          },
        },
        {
          dataField: 'active',
          text: t('activation'),
          headerStyle: {
            width: '100px',
          },
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('activation') },
          formatter: dataField => {
            const buttonStyles = {
              background: dataField ? '#f2e6ed' : '#9cdffc',
            };

            return (
              <button id={String(dataField)} style={buttonStyles} className="btn btn-primary more btn-active">
                {dataField ? t('turnOff') : t('turnOn')}
              </button>
            );
          },
        },
        {
          dataField: 'id',
          text: <div className="sticky-wrap">{t('options')}</div>,
          attrs: { 'data-label': t('options') },
          headerStyle: {
            width: '50px',
          },
          formatter: dataField => (
            <div className="actions-wrap">
              <div className="btn-wrap">
                <Tooltipe text="view" icon="icon-preview" btnClass="move-view" />
                <Tooltipe text="delete" icon="icon-delete" btnClass="move-delete" />
              </div>
            </div>
          ),
        },
      ]
    : [
        { dataField: 'id', hidden: true },
        {
          dataField: 'FIO',
          text: t('fio'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('fio') },
          sort: true,
        },
        {
          dataField: 'email',
          text: t('email'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('email') },
        },
        {
          dataField: 'age',
          text: t('age'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('age') },
          formatter: cell => {
            return cell !== '' ? cell : '-';
          },
        },
        {
          dataField: 'classStudent',
          text: t('class'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('class') },
          formatter: cell => {
            return cell !== '' ? cell : '-';
          },
        },
        {
          dataField: 'city',
          text: t('city'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('city') },
          formatter: cell => {
            return cell !== '' ? cell : '-';
          },
        },
        {
          dataField: 'branch',
          text: t('branch'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('branch') },
          formatter: cell => {
            return cell !== '' ? cell : '-';
          },
        },
        {
          dataField: 'subjects',
          text: t('subjects'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('subjects') },
          formatter: cell => {
            const filteredSubjects = [];
            for (let key in cell) {
              if (cell[key].attachedTeacher) {
                const id = JSON.parse(localStorage.getItem('user')).email.replace(/\./g, '');
                if (id === cell[key].attachedTeacher.id) {
                  filteredSubjects.push(t(`${cell[key].name}`));
                }
              }
            }
            const filteredObjectsLocale = filteredSubjects.sort((a, b) => t(a).localeCompare(t(b)));

            return (
              <>
                {filteredObjectsLocale.map(item => {
                  return (
                    <>
                      <span>{item}</span>
                      <br className="hideBr"></br>
                    </>
                  );
                })}
              </>
            );
          },
        },
        {
          dataField: 'active',
          text: t('activation'),
          headerStyle: {
            width: '100px',
          },
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('activation') },
          formatter: dataField => {
            const buttonStyles = {
              background: dataField ? '#f2e6ed' : '#9cdffc',
            };

            return (
              <button id={String(dataField)} style={buttonStyles} className="btn btn-primary more btn-active">
                {dataField ? t('turnOff') : t('turnOn')}
              </button>
            );
          },
        },
        {
          dataField: 'id',
          text: <div className="sticky-wrap">{t('options')}</div>,
          attrs: { 'data-label': t('options') },
          headerStyle: {
            width: '50px',
          },
          formatter: dataField => (
            <div className="actions-wrap">
              <Tooltipe text="view" icon="icon-preview" btnClass="move-view" />

              {userType === 'Teacher' && <Tooltipe text="delete" icon="icon-delete" btnClass="move-delete" />}
            </div>
          ),
        },
      ];

  const defaultSorted = [
    {
      dataField: 'FIO',
      order: 'asc',
    },
  ];

  const rowEvents = {
    onClick: async (e, row) => {
      const studentId = row.email?.replace(/\./g, '');

      if (e.target.className === 'btn btn-icon move-view') {
        sessionStorage.setItem('StudentView', JSON.stringify(row));
        navigate(`/studentView/${studentId}`, {
          state: { fio: row.FIO, studentMail: row.email },
        });
      }

      if (e.target.className === 'btn btn-primary more btn-active') {
        try {
          await update(ref(database, `Students/${studentId}`), {
            active: !row.active,
          });

          setStudentActive(prev => !prev);
          fetchStudentsListData();
          setStudentParamsId(studentId);
        } catch (error) {
          console.log(error);
          throwErrorRollbar(error);
        }
      }

      if (e.target.className === 'btn btn-icon move-delete') {
        try {
          localStorage.setItem('studentId', studentId);
          setPopupRemove(true);
        } catch (error) {
          console.log(error);
          throwErrorRollbar(error);
        }
      }
    },
  };

  const pageSize = 10;

  const pagination = paginationFactory({
    sizePerPage: pageSize,
    hideSizePerPage: true,
    page: selectedFilterAge.page,
    onPageChange: page => {
      selectedFilterAge.page = page;
      Cookies.set('selectedFilterAge', JSON.stringify(selectedFilterAge));
    },
  });

  const openModalCreateStudent = () => {
    setOpenModal(true);
  };

  return (
    <>
      <ToolkitProvider key={i18n.language} keyField="email" data={studetnItems} columns={columns} search>
        {props => (
          <div className="materials-page students-page container">
            <ul className="filters-list first-list">
              <li>
                <FormControl fullWidth>
                  <InputLabel id="class-hw-label">{t('class')}</InputLabel>
                  <Select
                    labelId="class-label"
                    id="class-hw-select"
                    value={selectedClass}
                    label={t('class')}
                    onChange={onStudentClass}
                    endAdornment={
                      selectedClass && (
                        <ResetButton
                          onClick={() => {
                            setSelectedClass('');
                            Cookies.set('selectedFilterClass', JSON.stringify({}));
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </ResetButton>
                      )
                    }
                  >
                    {unicClass.map((classSt, i) => {
                      return (
                        <MenuItem key={i} value={classSt}>
                          {classSt}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </li>

              <li>
                <FormControl fullWidth>
                  <InputLabel id="age-hw-label">{t('age')}</InputLabel>
                  <Select
                    labelId="age-label"
                    id="age-hw-select"
                    value={selectedAge}
                    label={t('age')}
                    onChange={onStudentAge}
                    endAdornment={
                      selectedAge && (
                        <ResetButton
                          onClick={() => {
                            setSelectedAge('');
                            Cookies.set('selectedFilterAge', JSON.stringify({}));
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </ResetButton>
                      )
                    }
                  >
                    {unicAge.map((age, i) => {
                      return (
                        <MenuItem key={i} value={age}>
                          {age}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </li>
              <li>
                <FormControl fullWidth>
                  <InputLabel id="city-hw-label">{t('city')}</InputLabel>
                  <Select
                    labelId="city-label"
                    id="city-hw-select"
                    value={selectedCity}
                    label={t('city')}
                    onChange={onStudentCity}
                    endAdornment={
                      selectedCity && (
                        <ResetButton
                          onClick={() => {
                            setSelectedCity('');
                            Cookies.set('selectedFilterCity', JSON.stringify({}));
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </ResetButton>
                      )
                    }
                  >
                    {unicCity.map((city, i) => {
                      return (
                        <MenuItem key={i} value={city}>
                          {city}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </li>
              <li>
                <FormControl fullWidth>
                  <InputLabel id="subject-hw-label">{t('subjectFilter')}</InputLabel>
                  <Select
                    labelId="subject-label"
                    id="subject-hw-select"
                    value={selectedSubject}
                    label={t('subjectFilter')}
                    onChange={onStudentSubject}
                    endAdornment={
                      selectedSubject && (
                        <ResetButton
                          onClick={() => {
                            setSelectedSubject('');
                            Cookies.set('selectedFilterSubject', JSON.stringify({}));
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </ResetButton>
                      )
                    }
                  >
                    {unicSubject
                      .sort((a, b) => t(a).localeCompare(t(b)))
                      .map((subject, i) => {
                        // const localeSubjectsArr = [];
                        // unicSubject.forEach(item => localeSubjectsArr.push(t(`${item}`)));
                        // localeSubjectsArr.sort((a, b) => a.localeCompare(b));

                        return (
                          <MenuItem key={i} value={subject}>
                            {t(subject)}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </li>
              <li>
                <FormControl fullWidth>
                  <InputLabel id="branch-hw-label">{t('branch')}</InputLabel>
                  <Select
                    labelId="branch-label"
                    id="branch-hw-select"
                    value={selectedBranch}
                    label={t('branch')}
                    onChange={onStudentBranch}
                    endAdornment={
                      selectedBranch && (
                        <ResetButton
                          onClick={() => {
                            setSelectedBranch('');
                            Cookies.set('selectedFilterBranch', JSON.stringify({}));
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </ResetButton>
                      )
                    }
                  >
                    {unicBranch.map((branch, i) => {
                      return (
                        <MenuItem key={i} value={branch}>
                          {branch}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </li>

              <li className="search-input">
                <SearchBar {...props.searchProps} srText="" placeholder={t('search')} ref={searchRef} />
              </li>
              {canManageStudents && (
                <li>
                  <Button className="btn clear-filter with-icon" onClick={() => openModalCreateStudent()}>
                    <span className="icon icon-plus"></span>
                    <span className="title">{t('createStudent')}</span>
                  </Button>
                </li>
              )}
              <li>
                <Button className="btn clear-filter" onClick={handleClearFilters}>
                  {t('clearFilter')}
                </Button>
              </li>
            </ul>
            <hr />
            <div className="materials-table">
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  {studetnItems && studetnItems.length ? (
                    <BootstrapTable
                      {...props.baseProps}
                      pagination={studetnItems.length > pageSize ? pagination : null}
                      rowEvents={rowEvents}
                      defaultSorted={defaultSorted}
                    />
                  ) : (
                    <NoItems titleNoItems={t('noStudents')} />
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </ToolkitProvider>

      {openModal && (
        <Modal
          open={openModal}
          setOpen={setOpenModal}
          title={t('createStudent')}
          submit={t('create')}
          nameAction={'createForm'}
          updateFormObj={''}
          student={student}
          fetchStudentsListData={fetchStudentsListData}
          userEmail={mail}
        />
      )}

      <div className={popupRemove ? 'popup-remove active' : 'popup-remove'}>
        <div className="popup-remove-content">
          <h3>{t('do you want delete student?')}</h3>
          <div className="btn-wrap">
            <button className="btn btn-primary more btn-active" onClick={() => removeStudent()}>
              {t('yes')}
            </button>
            <button className="btn more btn-view" onClick={notRemoveStudent}>
              {t('no')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentList;
